import React, { useEffect } from "react";
import Routes from "./router/Routes";
import ScrollToTop from "./components/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";
// import AnimatedCursor from "react-animated-cursor";

const App = () => {
  useEffect(() => {
    AOS.init();
    // Old API call removed — backend is now Supabase Edge Functions
    // RestClient.get(process.env.REACT_APP_API_URL);
  }, []);

  return (
    <>
      {/* <AnimatedCursor
        innerSize={8}
        outerSize={44}
        color="255, 160, 1"
        outerAlpha={0.3}
        innerScale={0.7}
        outerScale={1.2}
      /> */}
      <ScrollToTop />
      <Routes />
    </>
  );
};

export default App;
